import EnviromentConfig from "../../configs/enviromentConfig";
const API_URL = EnviromentConfig.API_URL;

export const api = {
      pagos: {
        async getPagoByInternalId(internalId) {
            const res = await fetch(`${API_URL}/api/pvs/link/status/${internalId}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        },
        async getPagosBySuministro(suministroId, cliCod) {
            const res = await fetch(`${API_URL}/api/pagos/${cliCod}/${suministroId}`, {
                method: "GET",
                headers: { 
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token'),
                },
            });
            if (!res.ok) throw await res.json();
            return await res.json();
        }
     }
     }
  